import { defineStore } from 'pinia'

import state from './state'
import getters from './getters'
import actions from './actions'

const useSettingsStore = defineStore('settings', {
  state,
  getters,
  actions
})

export default useSettingsStore
